module.exports = __webpack_public_path__ + "static/media/draw-celebration.5558a031.svg";